import createIcon from '../../createIcon';

/**
 * @component @name BatteryAlert
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNjcgNEgxNFYySDEwVjRIOC4zM0M3LjYgNCA3IDQuNiA3IDUuMzNWMjAuNjZDNyAyMS40IDcuNiAyMiA4LjMzIDIySDE1LjY2QzE2LjQgMjIgMTcgMjEuNCAxNyAyMC42N1Y1LjMzQzE3IDQuNiAxNi40IDQgMTUuNjcgNFpNMTMgMThIMTFWMTZIMTNWMThaTTEzIDE0SDExVjlIMTNWMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BatteryAlert = createIcon('BatteryAlert', [
  [
    'path',
    {
      d: 'M15.67 4H14V2H10V4H8.33C7.6 4 7 4.6 7 5.33V20.66C7 21.4 7.6 22 8.33 22H15.66C16.4 22 17 21.4 17 20.67V5.33C17 4.6 16.4 4 15.67 4ZM13 18H11V16H13V18ZM13 14H11V9H13V14Z',
      key: 'yq39kl',
    },
  ],
]);

export default BatteryAlert;
